import * as yup from 'yup';

// Schémas de validation Yup
const identityValidationSchema = yup.object().shape({
    civility: yup.string().required('La civilité est requise'),
    firstName: yup
        .string()
        .required('Le prénom est requis'),
    lastName: yup
        .string()
        .required('Le nom est requis')
});

export default identityValidationSchema